module.exports = __webpack_public_path__ + "static/media/getintouch.ad762a46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/pages/contact-us/img/getintouch.jpg
// module id = 1895
// module chunks = 147